import { Container, AppBar, Toolbar, Typography, IconButton, Card, CardHeader, FormControl, RadioGroup, FormControlLabel, Radio, SwipeableDrawer, TextField, Skeleton, Box } from '@mui/material';
import { ArrowBackOutlined, DeleteOutlineOutlined, SearchOutlined } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { createNewTheme } from '../functions/utils';
import * as React from 'react';

import axios from 'axios';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingComponent from '../components/LoadingComponent';
import Snackbar from '@mui/material/Snackbar';

import 'react-responsive-carousel/lib/styles/carousel.min.css';
import '@fontsource/roboto/400.css';
import { SpacerGustio } from '../components/DesignSystem/SpacerGustio';
import { ButtonGustio } from '../components/DesignSystem/ButtonGustio';

function SelecionarEndereco(props) {

  const { windows } = props;
  const state = useLocation().state;
  const [loading, setLoading] = useState(false);
  const page = state ? state.page : 'home';
  const [colorPrimary, setColorPrimary] = useState(state ? state.colorPrimary : "217, 217, 217");
  const [colorSecondary, setColorSecondary] = useState(state ? state.colorSecondary : "217, 217, 217");
  const [colorTertiary, setColorTertiary] = useState(state ? state.colorTertiary : "217, 217, 217");
  const [currentEndereco, setCurrentEndereco] = useState("");
  const [nomeEndereco, setNomeEndereco] = useState("");
  const [cep, setCep] = useState("");
  const [localidade, setLocalidade] = useState("");
  const [bairro, setBairro] = useState("");
  const [logradouro, setLogradouro] = useState("");
  const [uf, setUf] = useState("");
  const [nome, setNome] = useState("");
  const [numero, setNumero] = useState("");
  const [complemento, setComplemento] = useState("");
  const [enderecoEntrega, setEnderecoEntrega] = useState("");
  const [enderecos, setEnderecos] = useState([]);
  const [hasAddress, setHasAddress] = useState(false);
  const [open, setOpen] = useState(false);
  const [semLogradouro, setSemLogradouro] = useState(false);
  const [semBairro, setSemBairro] = useState(false);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [msgSnack, setMsgSnack] = React.useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [modalAlert, setModalAlert] = React.useState(false);

  const navigate = useNavigate();
  const container = windows !== undefined ? () => windows().document.body : undefined;

  const handleBack = () => {
    navigate("/enderecos", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
  };

  useEffect(() => {
    const handlePopState = (event) => {
      event.preventDefault();
      handleBack();
    };

    window.history.pushState(null, '', window.location.href);

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  const handleOpenLoading = () => {
    setLoading(true);
  };

  const handleCloseLoading = () => {
    setLoading(false);
  };

  const handleSnack = (title) => {
    setMsgSnack(title);
    setOpenSnack(true);
    handleCloseLoading();
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnack(false);
  };

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleCepChange = (event) => {
    setCep(event.target.value)
  };

  const handleNome = (event) => {
    setNome(event.target.value)
  };

  const handleLogradouro = (event) => {
    setLogradouro(event.target.value)
  };

  const handleBairro = (event) => {
    setBairro(event.target.value)
  };

  const handleNumero = (event) => {
    setNumero(event.target.value)
  };

  const handleComplemento = (event) => {
    setComplemento(event.target.value)
  };

  const handleCadastrar = () => {
    handleOpenLoading();
    const isLogged = localStorage.getItem('isLogged');

    if (isLogged) {
      if (!nome || !numero || numero.length === 0) {
        handleSnack("Por favor, preencha todos os campos corretamente para prosseguir.");
        return
      }

      const telefone = localStorage.getItem('tUsr').replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", "");
      const urlBase = localStorage.getItem('UBs');
      axios.post(`${urlBase}/cadastro-endereco.php`, {
        telefone: telefone.trim(),
        nome: nome.trim(),
        endereco: `${logradouro}, ${numero}, ${bairro}, ${localidade}, ${uf}, ${cep}, ${complemento}`.trim()
      })
        .then(response => {
          response = response.data
          getEnderecos();
          setOpen(false);
          handleCloseLoading();
        })
        .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente.")
        );
    } else {
      if (!nome || !numero || numero.length === 0) {
        handleSnack("Por favor, preencha todos os campos corretamente para prosseguir.");
        return
      }
      localStorage.setItem('eEA', `${logradouro}, ${numero}, ${bairro}, ${localidade}, ${uf}, ${cep}, ${complemento}`);
      localStorage.setItem('nmEA', nome);
      localStorage.setItem('iEA', "Avs");
      navigate("/enderecos", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
    }

  };

  // const handleContinuarCep = () => {
  //   handleOpenLoading();
  //   axios.get('https://viacep.com.br/ws/' + cep + '/json')
  //     .then(response => {
  //       response = response.data
  //       if (!response) {
  //         handleSnack("Por favor, preencha todos os campos corretamente para prosseguir.");
  //         setHasAddress(false)
  //         return
  //       }
  //       if (response.erro) {
  //         handleSnack("Não foi possivel encontrar o CEP, por favor verifique sua conexão com a internet.");
  //         setHasAddress(false)
  //         return
  //       }
  //       setHasAddress(true)
  //       setLogradouro(response.logradouro)
  //       setBairro(response.bairro)
  //       setLocalidade(response.localidade)
  //       setUf(response.uf)
  //       response.logradouro ? setSemLogradouro(false) : setSemLogradouro(true)
  //       response.bairro ? setSemBairro(false) : setSemBairro(true)
  //       handleCloseLoading();
  //     })
  //     .catch(error => handleErrorCep());
  // };

  const handleContinuarCep = () => {
    handleOpenLoading();
    axios.get('https://brasilapi.com.br/api/cep/v1/' + cep)
      .then(response => {
        response = response.data
        if (!response) {
          handleSnack("Por favor, preencha todos os campos corretamente para prosseguir.");
          setHasAddress(false)
          return
        }
        if (response.erro) {
          handleSnack("Não foi possivel encontrar o CEP, por favor verifique sua conexão com a internet.");
          setHasAddress(false)
          return
        }
        setHasAddress(true)
        setLogradouro(response.street)
        setBairro(response.neighborhood)
        setLocalidade(response.city)
        setUf(response.state)
        response.street ? setSemLogradouro(false) : setSemLogradouro(true)
        response.neighborhood ? setSemBairro(false) : setSemBairro(true)
        handleCloseLoading();
      })
      .catch(error => handleErrorCep());
  };

  const handleErrorCep = () => {
    setHasAddress(false)
    handleSnack("Não foi possivel encontrar o cep, por favor verifique sua conexão com a internet.");
    handleCloseLoading();
  };

  const handleNew = () => {
    setHasAddress(false)
    setLogradouro("")
    setBairro("")
    setLocalidade("")
    setUf("")
    setOpen(true);
    handleCloseLoading();
  };

  const handleSelecionar = () => {
    if (enderecoEntrega) {
      localStorage.setItem('tE', 0);
    }
    localStorage.setItem('eEA', enderecoEntrega);
    localStorage.setItem('nmEA', nomeEndereco);
    localStorage.setItem('iEA', currentEndereco);
    navigate("/enderecos", { replace: true, state: { page: page, colorPrimary: colorPrimary, colorSecondary: colorSecondary, colorTertiary: colorTertiary } })
  };

  const handleEndereco = (endereco) => {
    setCurrentEndereco(endereco.idendereco);
    setNomeEndereco(endereco.nome_endereco);
    setEnderecoEntrega(endereco.endereco);
  };

  const handleRemove = (endereco) => {
    setCurrentEndereco(endereco.idendereco);
    handleOpenModal("Atenção", `Essa é uma ação irreversível, você confirma a exclusão do endereço "${endereco.endereco}" de sua conta?`)
  };

  const handleExcluirEndereco = (endereco) => {

    const urlBase = localStorage.getItem('UBs');
    axios.post(`${urlBase}/deletar-endereco.php`, {
      id: currentEndereco
    })
      .then(response => {
        response = response.data
        if (!response) {
          handleSnack("Não foi possivel deletar seu endereço, verifique sua conexão e tente novamente.")
          return;
        }
        if (response.resposta === "falha") {
          handleSnack("Não foi possivel deletar seu endereço, verifique sua conexão e tente novamente.")
          return;
        }
        if (response.resposta === "sucesso") {
          getEnderecos();
          handleSnack("Endereço deletado com sucesso.");
          setModalAlert(false);
          return;
        }
        handleSnack("Não foi possivel deletar seu endereço, verifique sua conexão e tente novamente.")
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
    console.log(currentEndereco)
  };

  const handleOpenModal = (titleModal, descriptionModal) => {
    setTitle(titleModal);
    setDescription(descriptionModal);
    setModalAlert(true);
  };

  const handleCloseModal = () => {
    setModalAlert(false);
  };

  useEffect(() => {
    handleOpenLoading();

    const mainName = localStorage.getItem('Mn');
    document.title = mainName;
    const urlBase = localStorage.getItem('UBs');
    const favicon = document.querySelector('link[rel="icon"]');
    favicon.href = `${urlBase.replaceAll("/api", "")}/imagens/logo-store-${localStorage.getItem("Md")}.png?${new Date().getTime()}`;

    if (colorPrimary) {
      setColorPrimary(localStorage.getItem("clPmr"))
      setColorSecondary(localStorage.getItem("clScr"))
      setColorTertiary(localStorage.getItem("clTcr"))
    }

    const isLogged = localStorage.getItem('isLogged');

    if (isLogged) {
      getEnderecos()
      const idSelect = localStorage.getItem('iEA');
      if (idSelect) {
        const nomeSelect = localStorage.getItem('nmEA');
        const enderecoSelect = localStorage.getItem('eEA');
        setCurrentEndereco(idSelect)
        setNomeEndereco(nomeSelect);
        setEnderecoEntrega(enderecoSelect);
      }
    } else {
      handleNew();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getEnderecos = () => {
    handleOpenLoading();
    const telefone = localStorage.getItem('tUsr').replaceAll("(", "").replaceAll(")", "").replaceAll("-", "").replaceAll(" ", "");
    const urlBase = localStorage.getItem('UBs');
    axios.post(`${urlBase}/enderecos.php`, {
      numero: telefone.trim()
    })
      .then(response => {
        response = response.data
        setEnderecos(response)
        handleCloseLoading();
        if (!response) {
          localStorage.removeItem('eEA');
          localStorage.removeItem('nmEA');
          localStorage.removeItem('iEA');
        }
      })
      .catch(error => handleSnack("Não foi possivel conectar ao servidor, verifique sua conexão e tente novamente."));
  }

  return (
    <ThemeProvider theme={createNewTheme(colorPrimary, colorSecondary, colorTertiary)}>
      <Container>
        <AppBar position="absolute" style={{ backgroundColor: `rgba(${colorPrimary})`, color: "#FFF", fontWeight: "bold", boxShadow: "none", fontFamily: "roboto" }}>
          <Toolbar>
            <IconButton size="large" edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }} style={{ color: "#FFF" }} onClick={handleBack}>
              <ArrowBackOutlined />
            </IconButton>
            Endereços
            {/* <IconButton size="large" color="inherit" aria-label="menu" sx={{ mr: 0 }} style={{ color: "#FFF", marginLeft: "auto" }} onClick={handleNew}>
              <SearchOutlined />
            </IconButton> */}
          </Toolbar>
        </AppBar>

        <LoadingComponent open={loading} />

        <Snackbar
          open={openSnack}
          autoHideDuration={3000}
          onClose={handleClose}
          message={msgSnack}
        />

        <SpacerGustio height={70} />

        <Dialog
          open={modalAlert}
          onClose={handleCloseModal}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {title}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {description}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Box sx={{ p: "12px", display: "flex" }}>
              <ButtonGustio fullWidth={false} onClick={handleCloseModal}>Fechar</ButtonGustio>
              <SpacerGustio width={10} />
              <ButtonGustio fullWidth={false} onClick={handleExcluirEndereco}>Confirmar</ButtonGustio>
            </Box>
          </DialogActions>
        </Dialog>
        {!enderecos && (
          <Typography style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", margin: "0" }}>
            <Typography style={{ textAlign: "center", fontSize: "12px", color: "#999", minWidth: "300px" }}>

              <img alt="sem pedidos" src="https://gustio.com.br/imagens/no-order.png" />

              <SpacerGustio height={10} />

              Você não possui endereços cadastrados <br />Que tal cadastrar agora?

              <SpacerGustio height={20} />

              <ButtonGustio variant="text" onClick={handleNew}>Cadastrar novo endereço</ButtonGustio>
            </Typography>
          </Typography>
        )}

        {enderecos && (
          <>
            <ButtonGustio fullWidth startIcon={<SearchOutlined />} onClick={handleNew}> Buscar novo CEP </ButtonGustio>
            <SpacerGustio height={10} />
            {enderecos.length === 0 && (
              <>
                <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                  <CardHeader
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    action={
                      <IconButton size="large" color="inherit" aria-label="menu" sx={{ mr: 0 }} style={{ color: "#FF6347", marginLeft: "auto" }}>
                        <DeleteOutlineOutlined />
                      </IconButton>
                    }
                    title={<Skeleton animation="wave" height={30} width="100%" />}
                    subheader={<Skeleton animation="wave" height={30} width="100%" />}
                  />
                </Card>
                <SpacerGustio height={10} />
              </>
            )}
            <Typography style={{ color: "#1B1B1B", fontSize: "16px", fontWeight: "bold" }}>
              <SpacerGustio height={10} />
              {enderecos.map((endereco) => (
                <>
                  <Card variant="outlined" sx={{ borderRadius: "8px", width: "100%" }}>
                    <CardHeader
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      avatar={
                        <FormControl value={endereco.endereco}>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            onChange={() => handleEndereco(endereco)}
                          >
                            <FormControlLabel checked={currentEndereco === endereco.idendereco} value={currentEndereco} control={<Radio />} />
                          </RadioGroup>
                        </FormControl>
                      }
                      action={
                        <IconButton size="large" color="inherit" aria-label="menu" sx={{ mr: 0 }} style={{ color: "#FF6347", marginLeft: "auto" }} onClick={() => handleRemove(endereco)}>
                          <DeleteOutlineOutlined />
                        </IconButton>
                      }
                      title={endereco.nome_endereco}
                      titleTypographyProps={{ fontSize: "12px", fontWeight: "500", marginLeft: "-20px", color: "#999" }}
                      subheader={endereco.endereco}
                      subheaderTypographyProps={{ fontSize: "14px", fontWeight: "bold", marginLeft: "-20px", color: "#1B1B1B" }}
                    />
                  </Card>
                  <SpacerGustio height={10} />
                </>
              ))}
            </Typography>
          </>
        )}

        <SwipeableDrawer
          container={container}

          anchor="bottom"
          open={open}
          onClose={toggleDrawer(false)}
          onOpen={toggleDrawer(true)}
          disableSwipeToOpen={true}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <Box style={{ backgroundColor: "#D6D6D6", height: "4px", width: "32px", borderRadius: "100px", margin: "15px auto" }}></Box>

          {!hasAddress ? (
            <>
              <Typography style={{ fontSize: "12px", paddingLeft: "20px", color: "#464444", fontWeight: "bold" }}>
                Preencha o CEP (apenas números)
              </Typography>

              <SpacerGustio height={6} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={cep}
                  onChange={handleCepChange}
                  variant="outlined"
                  placeholder="CEP"
                  type="text"
                />
              </Typography>
              <Box sx={{ p: "20px" }}>
                <ButtonGustio onClick={handleContinuarCep}>Continuar</ButtonGustio>
              </Box>
            </>
          ) : (
            <>
              <Typography style={{ fontSize: "12px", paddingLeft: "20px", color: "#999", fontWeight: "bold" }}>
                Preencha número e dê um nome ao endereço
              </Typography>
              <SpacerGustio height={10} />
              {logradouro && (
                <Typography style={{ fontSize: "12px", paddingLeft: "20px", color: "#464444", fontWeight: "bold" }}>
                  {logradouro},
                </Typography>
              )}
              <Typography style={{ fontSize: "12px", paddingLeft: "20px", color: "#999", fontWeight: "bold" }}>
                {bairro ? `${bairro}, ` : ""} {localidade}, {uf} - {cep}
              </Typography>
              <SpacerGustio height={6} />
              {semLogradouro && (
                <>
                  <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                    <TextField
                      fullWidth
                      hiddenLabel
                      value={logradouro}
                      onChange={handleLogradouro}
                      variant="outlined"
                      placeholder="Logradouro (Nome da rua)"
                      type="text"
                    />
                  </Typography>
                  <SpacerGustio height={12} />
                </>
              )}
              {semBairro && (
                <>
                  <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                    <TextField
                      fullWidth
                      hiddenLabel
                      value={bairro}
                      onChange={handleBairro}
                      variant="outlined"
                      placeholder="Bairro"
                      type="text"
                    />
                  </Typography>
                  <SpacerGustio height={12} />
                </>
              )}
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={nome}
                  onChange={handleNome}
                  variant="outlined"
                  placeholder="Nome (casa)"
                  type="text"
                />
              </Typography>
              <SpacerGustio height={12} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={numero}
                  onChange={handleNumero}
                  variant="outlined"
                  placeholder="Número"
                  type="text"
                />
              </Typography>
              <SpacerGustio height={12} />
              <Typography style={{ paddingLeft: "20px", paddingRight: "22px" }}>
                <TextField
                  fullWidth
                  hiddenLabel
                  value={complemento}
                  onChange={handleComplemento}
                  variant="outlined"
                  placeholder="Complemento (opcional)"
                  inputProps={{ maxLength: 18 }}
                  type="text"
                />
              </Typography>
              <Box sx={{ p: "20px" }}>
                <ButtonGustio onClick={handleCadastrar}>Continuar</ButtonGustio>
              </Box>
            </>
          )}


        </SwipeableDrawer>

        {enderecos && localStorage.getItem('isLogged') && (
          <Box style={{ position: "fixed", bottom: "0", right: "0", left: "0", backgroundColor: "white", padding: "16px 16px 16px 16px" }}>
            <ButtonGustio onClick={handleSelecionar}> Selecionar endereço </ButtonGustio>
          </Box>
        )}

        <SpacerGustio height={100} />

      </Container>
    </ThemeProvider>
  );
}

export default SelecionarEndereco;